import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'
// Components
import { Modal, Radio } from 'semantic-ui-react'
import { Primary } from '../../components'
import {
  StyledModal,
  StyledLogo,
  StyledHeader,
  Container,
  StyledText,
  StyledTextSmall,
  StyledCheck,
  Gap,
  Divider,
  AnimatedContainer,
} from './PickYourPerksAmbEnrModal.styles'
// Contexts
import { useAuthContext } from '../../context/AuthContext'
import { useCartContext } from '../../context/CartContext'
import { usePrismic } from '../../context/PrismicContext'
// Utils
import { enrollSkus } from '../../utils/constants'
import { getAmbEnrollmentFees } from '../../utils/storeHelpers'
import { formatCurrency } from '../../utils/i18n/stores'

const PickYourPerksAmbEnrModal = ({ open, onClose }) => {
  const { qUser, qUserUpline } = useAuthContext()
  const {
    ambEnrollProducts,
    setAmbEnrollProducts,
    selectedAmbEnrollSku,
    setSelectedAmbEnrollSku,
    addSelectedAmbFeeToCart,
  } = useCartContext()
  const {
    langAndCountry,
    prismicData: { prismicPickYourPerksModal },
  } = usePrismic()

  const { ambPremiumSku, ambBasicSku } = enrollSkus
  const { premium, basic } = ambEnrollProducts

  const getFees = async () => {
    const { ambPremium, ambBasic } = await getAmbEnrollmentFees()
    setAmbEnrollProducts({
      premium: ambPremium,
      basic: ambBasic,
    })
  }

  const firstName = qUser?.legalFirstName
    ? qUser?.legalFirstName
    : qUser?.firstName ?? ''
  const lastName = qUser?.legalLastName
    ? qUser?.legalLastName
    : qUser?.lastName ?? ''

  useEffect(() => {
    getFees()
    setSelectedAmbEnrollSku(ambBasicSku)
  }, [enrollSkus])

  useEffect(() => {
    localStorage.removeItem('persistEnrollerData')
  }, [])

  const skuPriceMap = {
    [ambPremiumSku]: premium,
    [ambBasicSku]: basic,
  }

  const totalCost =
    skuPriceMap[selectedAmbEnrollSku]?.products?.items[0]?.price?.regularPrice
      ?.amount?.value

  const onHandleSkuChange = name => setSelectedAmbEnrollSku(name)

  const handleClose = () => {
    setSelectedAmbEnrollSku(null)
    navigate('/')
  }

  const onSubmit = () => {
    addSelectedAmbFeeToCart()
    onClose()
  }

  return (
    <StyledModal
      closeIcon
      open={open}
      centered={true}
      closeOnDimmerClick={true}
      closeOnEscape={true}
      onClose={handleClose}
    >
      <Container direction="column">
        <StyledLogo src="https://shopq.cdn.prismic.io/shopq/06ea17c4-0c65-4563-9507-bc314540e05f_black-q-sciences.svg" />
        <Gap />
        <StyledTextSmall weight={900}>
          {prismicPickYourPerksModal.ambassador_enrollment[0].text}
        </StyledTextSmall>
        <Gap />
        {qUserUpline?.displayName.length > 0 && (
          <StyledTextSmall>{`(${prismicPickYourPerksModal.referred_by[0].text}: ${qUserUpline?.displayName})`}</StyledTextSmall>
        )}
        <Gap height="16px" />
        <StyledText>
          {`${prismicPickYourPerksModal.welcome[0].text} ${firstName} ${lastName}! ${prismicPickYourPerksModal.time_to_enroll[0].text}`}
        </StyledText>
        <Gap height="16px" />
        <StyledHeader>
          {prismicPickYourPerksModal.your_perks[0].text}
        </StyledHeader>
      </Container>
      <Modal.Content>
        <Container direction="column">
          <Container direction="column" style={{ paddingLeft: 16 }}>
            <Container justify="flex-start">
              <StyledCheck />
              <StyledText align="left">
                {prismicPickYourPerksModal.full_access_to_arq[0].text}
              </StyledText>
            </Container>
            <Container justify="flex-start" style={{ paddingLeft: 40 }}>
              <StyledTextSmall align="left">
                {prismicPickYourPerksModal.arq_benefits[0].text}
              </StyledTextSmall>
            </Container>
            <Gap />

            <Container justify="flex-start">
              <StyledCheck />
              <StyledText align="left">
                {prismicPickYourPerksModal.full_access_to_myqfit[0].text}
              </StyledText>
            </Container>
            <Container justify="flex-start" style={{ paddingLeft: 40 }}>
              <StyledTextSmall align="left">
                {prismicPickYourPerksModal.myqfit_benefits[0].text}
              </StyledTextSmall>
            </Container>
          </Container>
        </Container>
        <Gap height="12px" />

        <Container direction="column" padding="0">
          {totalCost ? (
            <AnimatedContainer>
              <StyledText weight={900}>{`${
                prismicPickYourPerksModal.total[0].text
              }: ${formatCurrency(langAndCountry, totalCost)}`}</StyledText>
            </AnimatedContainer>
          ) : (
            <Gap height="32px" />
          )}
          <Gap height="24px" />
          <Primary onClick={onSubmit} content={`${'continue'.toUpperCase()}`} />
        </Container>
      </Modal.Content>
    </StyledModal>
  )
}

PickYourPerksAmbEnrModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default PickYourPerksAmbEnrModal
